/// <reference types="../commons.d.ts" preserve="true" />
/**
 * This module provides a wrapper around the Web storage API and provides extended functionality and error handling.
 *
 * {@include ../lib/storage/README.md}
 * @category Core Modules
 * @module storage
 * @packageDocumentation
 */
export type * from "../lib/storage/types.js";
export const { globalStorage: storage } = window.o_global ?? {};
